import { GiPerson } from "react-icons/gi";
import { SignatureUnitIcons, UnitClassIcons } from "./icons";

// Full unit-id → painterly PNG map. 16 unit portraits sliced from a DALL-E
// collage organized 4 elements × 4 classes. Files live in
// /webapp/public/icons/units/.
export const UnitPngById: Record<string, string> = {
  // Fire
  "fire-guardian": "/icons/units/fire-guardian.png",
  "fire-archer": "/icons/units/fire-archer.png",
  "fire-pyromancer": "/icons/units/fire-pyromancer.png",
  "fire-phoenix": "/icons/units/fire-phoenix.png",
  // Water
  "water-golem": "/icons/units/water-golem.png",
  "water-archer": "/icons/units/water-archer.png",
  "water-cryomancer": "/icons/units/water-cryomancer.png",
  "water-mermaid": "/icons/units/water-mermaid.png",
  // Air
  "air-harpy": "/icons/units/air-harpy.png",
  "air-archer": "/icons/units/air-archer.png",
  "air-aero": "/icons/units/air-aero.png",
  "air-griffin": "/icons/units/air-griffin.png",
  // Earth
  "earth-golem": "/icons/units/earth-golem.png",
  "earth-quaker": "/icons/units/earth-quaker.png",
  "earth-geo": "/icons/units/earth-geo.png",
  "earth-titan": "/icons/units/earth-titan.png",
};

// Generic class portraits, kept as fallback for camp / monster units that
// don't have element-specific painterly art yet.
export const ClassPngByCls: Record<number, string> = {
  0: "/icons/units/class-infantry.png",
  1: "/icons/units/class-ranger.png",
  2: "/icons/units/class-mage.png",
  3: "/icons/units/class-elite.png",
};

export function UnitIcon({
  unitId,
  cls,
  size = 22,
  rounded = "md",
}: {
  unitId?: string;
  cls: number | undefined;
  size?: number;
  rounded?: "md" | "lg" | "xl" | "2xl" | "none";
}) {
  const src =
    (unitId && UnitPngById[unitId]) ||
    (cls != null && ClassPngByCls[cls]) ||
    null;
  const radiusClass =
    rounded === "none" ? "" :
    rounded === "md"   ? "rounded-md" :
    rounded === "lg"   ? "rounded-lg" :
    rounded === "xl"   ? "rounded-xl" :
                         "rounded-2xl";
  if (src) {
    return (
      <img
        src={src}
        width={size}
        height={size}
        alt=""
        className={`h-full w-full ${radiusClass} object-cover`}
        loading="lazy"
      />
    );
  }
  const sig = unitId ? SignatureUnitIcons[unitId] : undefined;
  const Icon = sig ?? (cls != null ? UnitClassIcons[cls] : undefined) ?? GiPerson;
  return <Icon size={size} />;
}
